import React from 'react';  
import './DownloadSection.css';

import { DownloadType } from 'lib/Types';
import Section from 'components/Section/Section';

import translationsJson from 'data/translations.json';

const translations: Translations = translationsJson;

interface Props {
    type: DownloadType
}

export default class DownloadSection extends React.Component<Props, {}> {
	render() {
        const content = [];
        content.push(<h4 key="title">{translations.downloads[window.lang]}</h4>)
        switch(this.props.type) {
            case DownloadType.Firstnames:
                content.push(<div className='download-element' key="link1"><span>{translations.firstnameDownloadMale[window.lang]}</span><a download href={`download/${translations.greaterThanMinFirstnamesMaleFile[window.lang]}`}>{translations.download[window.lang]}</a></div>);
                content.push(<div className='download-element' key="link2"><span>{translations.firstnameDownloadFemale[window.lang]}</span><a download href={`download/${translations.greaterThanMinFirstnamesFemaleFile[window.lang]}`}>{translations.download[window.lang]}</a></div>);
                content.push(<div className='download-element' key="link3"><span>{translations.excludedFirstnameDownload[window.lang]}</span><a download href={`download/${translations.lessThanMinFirstnamesFile[window.lang]}`}>{translations.download[window.lang]}</a></div>);
                break;
            case DownloadType.Lastnames:
                content.push(<div className='download-element' key="link1"><span>{translations.lastnameDownload[window.lang]}</span><a download href={`download/${translations.greaterThanMinLastnamesFile[window.lang]}`}>{translations.download[window.lang]}</a></div>);
                content.push(<div className='download-element' key="link2"><span>{translations.excludedLastnameDownload[window.lang]}</span><a download href={`download/${translations.lessThanMinLastnamesFile[window.lang]}`}>{translations.download[window.lang]}</a></div>);
                break;
            case DownloadType.Newborns:
                content.push(<div className='download-element' key="link1"><span>{translations.newbornDownloadMale[window.lang]}</span><a download href={`download/${translations.newbornMaleFile[window.lang]}`}>{translations.download[window.lang]}</a></div>);
                content.push(<div className='download-element' key="link2"><span>{translations.newbornDownloadFemale[window.lang]}</span><a download href={`download/${translations.newbornFemaleFile[window.lang]}`}>{translations.download[window.lang]}</a></div>);
                break;
        }
        return (
            <Section>
                {content}
            </Section>
        );
	}
}